var render = function render(){var _vm=this,_c=_vm._self._c;return _c('center',[_c('feather-icon',{attrs:{"icon":_vm.iconVerified,"svgClasses":['h-5 w-5', _vm.textColor]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }